module.exports = __webpack_public_path__ + "static/media/9News.7e6aa015.jpg";